import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-53afbab7"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "course-card-cover"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "course-card-info"
};
const _hoisted_4 = {
  class: "top"
};
const _hoisted_5 = {
  class: "course-name text-overflow"
};
const _hoisted_6 = {
  class: "course-info"
};
const _hoisted_7 = {
  class: "item"
};
const _hoisted_8 = {
  class: "val"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "选课人数", -1));

const _hoisted_10 = {
  class: "item"
};
const _hoisted_11 = {
  class: "val"
};

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "学习资源", -1));

const _hoisted_13 = {
  class: "item"
};
const _hoisted_14 = {
  class: "val"
};

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "课堂录像", -1));

const _hoisted_16 = {
  class: "bottom"
};
const _hoisted_17 = {
  class: "teacher"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  class: "name"
};
const _hoisted_20 = {
  class: "time"
};
import { formatDate } from '@/plugins/utils';
import { handleLogin } from '@/plugins/utils';
export default {
  props: {
    info: {
      type: Object
    },
    userInfo: {
      type: Object,
      default: null
    },
    authType: Number,
    showResultTag: Boolean,
    resultMap: Object
  },

  setup(__props) {
    const props = __props;

    const goDetail = () => {
      if (unref(props.authType) == 2 && !unref(props.userInfo)) {
        handleLogin();
      } else {
        props.info.course_url && window.open(unref(props.info.course_url));
      }
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        onClick: goDetail,
        class: "course-card"
      }, [__props.showResultTag && __props.info.results_id ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "tag-btn",
        style: _normalizeStyle({
          background: __props.resultMap[__props.info.results_id]
        })
      }, _toDisplayString(__props.info.results_name), 5)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
        src: __props.info.course_cover_url || require('@/assets/images/common/course_cover.png')
      }, null, 8, _hoisted_2)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(__props.info.course_name), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(__props.info.students_num || 0), 1), _hoisted_9]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(__props.info.publish_resources_num || 0), 1), _hoisted_12]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(__props.info.video_record || 0), 1), _hoisted_15])])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("img", {
        class: "avatar",
        src: __props.info.avatar || require('@/assets/images/user_avatar.jpg')
      }, null, 8, _hoisted_18), _createElementVNode("div", _hoisted_19, _toDisplayString(__props.info.lecturer), 1)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("span", null, _toDisplayString(__props.info.term_name), 1)])])])]);
    };
  }

};